var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c(_vm.tag,{tag:"small",staticClass:"muted badge f-w-300 my-1",class:_vm.colorComputed},[_vm._v(" "+_vm._s(_vm.$t(("request.statuses." + _vm.status))))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }